export default __webpack_public_path__ + "static/media/image01.608b9513.svg";